export default __webpack_public_path__ + "de.5a743687.svg";